// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
  -webkit-text-fill-color: #555 !important;
}

.icone.not-animated {
  opacity: 1;
}

.response-message {
  margin-bottom: 20px;
}

.swal2-icon.swal2-success .swal2-success-ring {
  border: 0.25em solid #00caff;
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #00caff;
}

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #00caff;
}

.icone-check .path-1 {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash-stroke-1 2s ease-out forwards 0.25s;
}
@keyframes dash-stroke-1 {
  to {
    stroke-dashoffset: 0;
  }
}
.icone-check .path-2 {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash-stroke-2 3s ease forwards 0.55s;
}
@keyframes dash-stroke-2 {
  to {
    stroke-dashoffset: 0;
  }
}

.help-block {
  margin-top: 5px;
}

ul {
  list-style-type: none;
  margin-top: 40px;
  padding: 0;
}
ul li {
  height: 40px;
  line-height: 36px;
  text-align: left;
  border: 2px solid #e2e2e2;
  border-radius: 6px;
  margin-bottom: 15px;
  padding: 0 10px;
  background-color: #fff;
  font-size: 12px;
  color: #6a5cff;
  display: flex;
  align-items: center;
}
ul li span:first-child {
  height: 38px;
}
ul li span:first-child svg {
  vertical-align: middle;
  width: 32px;
}
ul li span:last-child {
  margin-left: 10px;
}

.big-link {
  font-size: 20px;
  font-weight: 600;
  font-family: "Pague.la", "Open Sans", sans-serif;
  color: #6a5cff;
}
.big-link:hover, .big-link:active, .big-link:focus {
  color: #6a5cff;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/auth/components/criar-senha/criar-senha.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAEA;EACI,mBAAA;EACA,YAAA;AADJ;;AAIA;;;;EAII,8CAAA;EACA,yDAAA;EAAA,iDAAA;EACA,wCAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,mBAAA;AADJ;;AAIA;EACI,4BAAA;AADJ;;AAIA;EACI,yBCtBO;ADqBX;;AAIA;EACI,yBC1BO;ADyBX;;AAKI;EACI,sBAAA;EACA,uBAAA;EACA,mDAAA;AAFR;AAII;EACI;IACI,oBAAA;EAFV;AACF;AAKI;EACI,sBAAA;EACA,uBAAA;EACA,+CAAA;AAHR;AAKI;EACI;IACI,oBAAA;EAHV;AACF;;AAOA;EACI,eAAA;AAJJ;;AAOA;EACI,qBAAA;EACA,gBAAA;EACA,UAAA;AAJJ;AAMI;EACI,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,cCrEE;EDsEF,aAAA;EACA,mBAAA;AAJR;AAMQ;EACI,YAAA;AAJZ;AAMY;EACI,sBAAA;EACA,WAAA;AAJhB;AAQQ;EACI,iBAAA;AANZ;;AAWA;EACI,eAAA;EACA,gBAAA;EACA,gDC7Da;ED8Db,cC5FM;ADoFV;AAUI;EACI,cC/FE;ADuFV","sourcesContent":["@import '../../../../../sass/variables';\n\n.btn-disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0px 1000px white inset;\n    transition: background-color 5000s ease-in-out 0s;\n    -webkit-text-fill-color: #555 !important;\n}\n\n.icone.not-animated {\n    opacity: 1;\n}\n\n.response-message {\n    margin-bottom: 20px;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n    border: 0.25em solid $azul-300;\n}\n\n.swal2-icon.swal2-success [class^='swal2-success-line'] {\n    background-color: $azul-300;\n}\n\n.swal2-icon.swal2-success [class^='swal2-success-line'] {\n    background-color: $azul-300;\n}\n\n.icone-check {\n    .path-1 {\n        stroke-dasharray: 1000;\n        stroke-dashoffset: 1000;\n        animation: dash-stroke-1 2s ease-out forwards 0.25s;\n    }\n    @keyframes dash-stroke-1 {\n        to {\n            stroke-dashoffset: 0;\n        }\n    }\n\n    .path-2 {\n        stroke-dasharray: 1000;\n        stroke-dashoffset: 1000;\n        animation: dash-stroke-2 3s ease forwards 0.55s;\n    }\n    @keyframes dash-stroke-2 {\n        to {\n            stroke-dashoffset: 0;\n        }\n    }\n}\n\n.help-block {\n    margin-top: 5px;\n}\n\nul {\n    list-style-type: none;\n    margin-top: 40px;\n    padding: 0;\n    \n    li {\n        height: 40px;\n        line-height: 36px;\n        text-align: left;\n        border: 2px solid $cinza-300;\n        border-radius: 6px;\n        margin-bottom: 15px;\n        padding: 0 10px;\n        background-color: #fff;\n        font-size: 12px;\n        color: $primary;\n        display: flex;\n        align-items: center;\n\n        span:first-child {\n            height: 38px;\n\n            svg {\n                vertical-align: middle;\n                width: 32px;\n            }\n        }\n\n        span:last-child {\n            margin-left: 10px;\n        }\n    }\n}\n\n.big-link {\n    font-size: 20px;\n    font-weight: 600;\n    font-family: $fonte-pague-la;\n    color: $primary;\n\n    &:hover, &:active, &:focus {\n        color: $primary;\n    }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
